// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = Symbol('Call API');
export default CALL_API;
